import JsonData from "./data.json";

const baseUrl = JsonData.baseUrl;
const logoUrl = `${baseUrl}/static/img/logo.webp`;

const commonData = {
  title: "Lift Blesk",
  description: "Реставрация лифтов и металлических поверхностей: шлифовка, полировка и устранение дефектов.",
  image: logoUrl,
};

export const schemaData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: commonData.title,
  url: baseUrl,
  sameAs: ["https://t.me/lift_blesk", "https://wa.me/+79216546574", "https://www.avito.ru/sankt-peterburg/predlozheniya_uslug/udalenie_tsarapin_v_lifte_3063808631"],
  logo: logoUrl,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+7 (921) 654-65-74",
    email: "liftblesk@ya.ru",
    contactType: "Обслуживание клиентов",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Салтыковская дорога, 4",
    addressLocality: "Санкт-Петербург",
    postalCode: "195253",
    addressCountry: "RU",
  },
};

export const ogData = {
  ...commonData,
  url: baseUrl,
  type: "website",
  locale: "ru_RU",
};

export const twitterData = {
  card: "summary",
  ...commonData,
  site: baseUrl,
  creator: commonData.title,
};
